import { AgreementDTO } from '../Types/DocumentT';
import { ajaxActions } from './AjaxActions';
import { ConstantS } from './ConstantS';
import { MixpanelS } from './MixpanelS';
import { ToastS } from './ToastS';

const BASE_URL = `${process.env.REACT_APP_DOCUMENT_SERVICE_URL}/agreements`;

const create = async (documentId: number): Promise<AgreementDTO | null> => {
  const res = await ajaxActions.post(`${BASE_URL}?documentType=contracts&documentId=${documentId}`);
  if (res.ok) {
    MixpanelS.track(ConstantS.TrackingEvents.AgreementCreated);
    return res.json();
  }
  ToastS.generalError();
  return null;
};

const createForTemplate = async (documentId: number): Promise<AgreementDTO | null> => {
  const res = await ajaxActions.post(`${BASE_URL}/templates?documentType=contracts&documentId=${documentId}`);
  if (res.ok) {
    MixpanelS.track(ConstantS.TrackingEvents.AgreementCreated, { template: true });
    return res.json();
  }
  ToastS.generalError();
  return null;
};

const update = async (id: string, patch: Partial<AgreementDTO>, documentId?: number): Promise<AgreementDTO | null> => {
  const res = await ajaxActions.patch(
    `${BASE_URL}/${id}${documentId ? `?documentType=contracts&documentId=${documentId}` : ''}`,
    patch,
  );
  if (res.ok) {
    return res.json();
  }
  return null;
};

const remove = async (id: string, documentId: number): Promise<boolean> => {
  const res = await ajaxActions.del(`${BASE_URL}/${id}/?documentType=contracts&documentId=${documentId}`);
  if (res.ok) {
    MixpanelS.track(ConstantS.TrackingEvents.AgreementDeleted);
    return true;
  }
  ToastS.generalError();
  return false;
};

const removeFromTemplate = async (id: string, documentId: number): Promise<boolean> => {
  const res = await ajaxActions.del(`${BASE_URL}/${id}/templates?documentType=contracts&documentId=${documentId}`);
  if (res.ok) {
    MixpanelS.track(ConstantS.TrackingEvents.AgreementDeleted, { template: true });
    return true;
  }
  ToastS.generalError();
  return false;
};

// eslint-disable-next-line import/prefer-default-export
export const AgreementS = {
  create,
  createForTemplate,
  update,
  remove,
  removeFromTemplate,
};
